import { useQuery } from '@tanstack/react-query'

import { chatService } from '@/services/chat'

export function useChatFeatures(enabled = true) {
  return useQuery({
    queryKey: ['chat-features'],
    queryFn: () => chatService.getFeatures(),
    enabled,
    staleTime: 60_000,
    retry: 1,
  })
}
